// Phase 6.9 C2 — one card in the «Лента событий».

import { useNavigate } from 'react-router-dom';

import type { EventFeedCard } from '../api/types';
import { feedDetail, feedKindLabel, feedTime } from '../lib/eventFeedFormat';

export function EventFeedCardRow({ card }: { card: EventFeedCard }) {
  const navigate = useNavigate();
  const detail = feedDetail(card);
  return (
    <div
      className={`feed-card sev-${card.severity}`}
      data-testid="event-feed-card"
      data-kind={card.kind}
    >
      <div className="feed-card-head">
        <span className="feed-card-title">{feedKindLabel(card.kind)}</span>
        {card.count > 1 && (
          <span className="feed-card-count" data-testid="feed-card-count">
            ×{card.count}
          </span>
        )}
        <span className="feed-card-time">{feedTime(card.ts)}</span>
      </div>
      {detail && <div className="feed-card-detail">{detail}</div>}
      {card.job_id !== null && (
        <button
          type="button"
          className="feed-card-jobid"
          onClick={() => navigate(`/job/${card.job_id}`)}
        >
          #{card.job_id}
        </button>
      )}
    </div>
  );
}
